// Styles
import { makeStyles, tokens } from "@fluentui/react-components";
// Utilities
import { flexParent, flexChildSizeFixed, flexChildSizeFlexible } from "@ms/planner-generic-controls/lib/local/utilities/Mixin.styles";
/**
 * Styles for the LeftNavPinnedSection component
 */ export const useLeftNavPinnedSectionStyles = makeStyles({
    root: {
        ...flexParent("column"),
        minHeight: tokens.spacingVerticalNone,
        flex: "1 1 auto",
        overflow: "visible"
    },
    rootCollapsed: {
        display: "none"
    },
    pinnedSectionHeader: {
        ...flexParent("column"),
        ...flexChildSizeFixed("24px"),
        overflow: "hidden",
        padding: `${tokens.spacingVerticalS} ${tokens.spacingHorizontalNone}`,
        marginInlineStart: tokens.spacingHorizontalXL,
        fontSize: tokens.fontSizeBase200,
        fontStyle: "normal",
        fontWeight: tokens.fontWeightRegular,
        justifyContent: "center",
        color: tokens.colorNeutralForeground2
    },
    pinnedSectionContainer: {
        ...flexParent("column"),
        ...flexChildSizeFlexible("auto"),
        minHeight: tokens.spacingVerticalNone,
        flex: "1 1 auto"
    },
    leftNavOptionsList: {
        margin: tokens.spacingVerticalNone,
        padding: tokens.spacingVerticalNone,
        listStyleType: "none",
        flex: "1 1 auto",
        minHeight: tokens.spacingVerticalNone,
        overflow: "visible"
    },
    emptyPinnedSectionContent: {
        color: tokens.colorNeutralForeground3,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        paddingLeft: tokens.spacingHorizontalXL,
        paddingRight: tokens.spacingHorizontalM,
        paddingTop: tokens.spacingVerticalXS,
        paddingBottom: tokens.spacingVerticalM
    },
    errorPinnedSectionContent: {
        paddingLeft: tokens.spacingHorizontalM,
        paddingRight: tokens.spacingHorizontalM,
        paddingTop: tokens.spacingVerticalXS,
        paddingBottom: tokens.spacingVerticalM,
        color: tokens.colorNeutralForeground3
    },
    errorMessage: {
        display: "flex",
        alignItems: "center",
        gap: tokens.spacingHorizontalXS,
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        marginBottom: tokens.spacingVerticalXS
    },
    retryButton: {
        backgroundColor: "transparent",
        border: "none",
        color: tokens.colorBrandForeground1,
        cursor: "pointer",
        fontSize: tokens.fontSizeBase200,
        lineHeight: tokens.lineHeightBase200,
        padding: tokens.spacingVerticalNone,
        textDecoration: "underline",
        "&:hover": {
            color: tokens.colorBrandForeground2Hover
        },
        "&:active": {
            color: tokens.colorBrandForeground2Pressed
        }
    }
});
